import { useLocale } from '@capsicum/common';
import { type ObjectDataShape } from '@capsicum/socios-core';
import { useMemo } from 'react';

export type FormVariationProps = {
	images: Array<ObjectDataShape>;
	language: {
		id: string;
		locale: string;
		name: string;
	};
};

export const useFormPost = (object?: ObjectDataShape) => {
	const { locale } = useLocale();
	const parsedLocale = locale?.split('-').join('_');

	const defaultVariationImages = useMemo(() => object?.defaultVariation?.images[0] ?? {}, [object]);

	const variationImages = useMemo(
		() =>
			object?.formVariations.find((variation: FormVariationProps) => variation.language.locale === parsedLocale)
				?.images,
		[object, locale]
	);

	return {
		imageObject: variationImages?.[0] ?? (defaultVariationImages as ObjectDataShape)
	};
};
